<template>
  <div>
    <span v-for="item in spans" :key="item.key" :class="item.classes">
      {{ item.text }}
    </span>
  </div>
</template>

<style scoped></style>

<script>
export default {
  props: {
    matchData: Object,
    corpus: Object,
    textField: String
  },

  computed: {
    spans: function() {
      const output = [];
      const { ref } = this.matchData;
      const { metadata } = this.matchData.matchData;
      const text_field = this.textField;
      const text = this.corpus[ref][text_field];
      //const split_re = /[A-Za-zÁÉÍÓÚáéíóúÀÈÌÒÙàèìòùÂÊÎÔÛâêîôûÃẼĨÕŨãẽĩõũÄËÏÖÜäëïöüÇç]+/g
      const split_re = /\S+/g;

      const match_words = Object.keys(metadata);
      const positions = [];
      match_words.forEach(w => {
        const word_positions = metadata[w][text_field].position;
        positions.push(...word_positions);
      });

      const _make_span = (key, text, highlight) => ({
        key,
        text,
        classes: highlight ? { "bg-warning": true } : {}
      });

      let match = null;
      let highlight = false;
      let span_key = 0;
      while (true) {
        match = split_re.exec(text);
        if (match === null) break;

        highlight = false;
        positions.forEach(([i, l]) => {
          if (i < split_re.lastIndex && i + l > match.index) highlight = true;
        });

        output.push(_make_span(span_key, match[0], highlight));
        span_key += 1;
      }

      return output;
    }
  }
};
</script>
